import styled from 'styled-components'
import { Modal } from 'common-components'

const Dialog = styled(Modal).attrs({
  modalClassName: 'ltr-modal scrollable-modal',
  backdrop: false,
})`
  .modal-body {
    padding: 0;
    background: ${({ theme }) => theme.variables['$color-wild-sand']};
  }
  .modal-footer {
    justify-content: center;
  }
`

export default Dialog
